__webpack_require__.p = "/competencies/";